class HomeCommunityReviews extends HTMLElement {
  connectedCallback() {
    var _a, _b, _c;
    (_a = this.events) == null ? void 0 : _a.abort();
    (_b = this.resizeObserver) == null ? void 0 : _b.disconnect();
    (_c = this.visibilityObserver) == null ? void 0 : _c.disconnect();
    cancelAnimationFrame(this.navigationFrame);
    this.navigationFrame = null;
    this.events = new AbortController();
    const { signal } = this.events;
    this.track = this.querySelector("[data-reviews-track]");
    this.prev = this.querySelector("[data-reviews-prev]");
    this.next = this.querySelector("[data-reviews-next]");
    if (!this.track || !this.prev || !this.next) return;
    this.prev.addEventListener("click", () => this.step(-1), { signal });
    this.next.addEventListener("click", () => this.step(1), { signal });
    this.track.addEventListener("scroll", () => this.queueNavigationUpdate(), { passive: true, signal });
    this.resizeObserver = new ResizeObserver(() => this.queueNavigationUpdate());
    this.resizeObserver.observe(this.track);
    this.querySelectorAll("[data-review-card]").forEach((card) => this.resizeObserver.observe(card));
    this.visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) entry.target.pause();
      });
    });
    this.querySelectorAll("[data-review-video-play]").forEach((button) => {
      button.addEventListener("click", () => this.playVideo(button), { signal });
      const video = button.parentElement.querySelector("[data-review-video-mount] video");
      if (video) this.watchVideo(video, button);
    });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) this.pauseVideos();
    }, { signal });
    document.addEventListener("shopify:block:select", (event) => {
      if (!this.contains(event.target)) return;
      const card = event.target.closest("[data-review-card]");
      if (card) card.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "auto" });
    }, { signal });
    this.updateNavigation();
  }
  disconnectedCallback() {
    var _a, _b, _c;
    (_a = this.events) == null ? void 0 : _a.abort();
    (_b = this.resizeObserver) == null ? void 0 : _b.disconnect();
    (_c = this.visibilityObserver) == null ? void 0 : _c.disconnect();
    cancelAnimationFrame(this.navigationFrame);
    this.navigationFrame = null;
    this.pauseVideos();
    this.querySelectorAll("[data-review-video-play]").forEach((button) => {
      button.disabled = false;
      button.hidden = false;
    });
  }
  queueNavigationUpdate() {
    if (this.navigationFrame != null) return;
    this.navigationFrame = requestAnimationFrame(() => {
      this.navigationFrame = null;
      this.updateNavigation();
    });
  }
  updateNavigation() {
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.prev.disabled = this.track.scrollLeft <= 1;
    this.next.disabled = this.track.scrollLeft >= maximum - 1;
  }
  step(direction) {
    const card = this.querySelector("[data-review-card]");
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const stride = card.getBoundingClientRect().width + gap;
    const count = Math.max(1, Math.floor((this.track.clientWidth + gap) / stride));
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const left = Math.max(0, Math.min(maximum, this.track.scrollLeft + direction * count * stride));
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.track.scrollTo({ left, behavior: reducedMotion ? "auto" : "smooth" });
  }
  pauseVideos(except) {
    this.querySelectorAll("[data-review-video-mount] video").forEach((video) => {
      if (video !== except) video.pause();
    });
  }
  watchVideo(video, button) {
    const { signal } = this.events;
    video.addEventListener("play", () => {
      this.pauseVideos(video);
      button.hidden = true;
    }, { signal });
    video.addEventListener("ended", () => {
      button.hidden = false;
    }, { signal });
    video.addEventListener("error", () => {
      button.disabled = false;
      button.hidden = false;
    }, { signal });
    this.visibilityObserver.observe(video);
  }
  async playVideo(button) {
    const { signal } = this.events;
    const media = button.parentElement;
    const mount = media.querySelector("[data-review-video-mount]");
    const template = media.querySelector("[data-review-video-template]");
    if (!mount || !template || button.disabled) return;
    let video = mount.querySelector("video");
    if (!video) {
      mount.append(template.content.cloneNode(true));
      video = mount.querySelector("video");
      if (!video) return;
      video.setAttribute("aria-label", button.getAttribute("aria-label"));
      this.watchVideo(video, button);
    }
    button.disabled = true;
    video.controls = true;
    try {
      await video.play();
    } catch {
      if (!signal.aborted) button.hidden = false;
    } finally {
      if (!signal.aborted) button.disabled = false;
    }
  }
}
if (!customElements.get("home-community-reviews")) {
  customElements.define("home-community-reviews", HomeCommunityReviews);
}
